import React, { createContext, useContext, useState, ReactNode } from 'react';

interface Error404ContextType {
  isNotFound: boolean;
  setNotFound: (notFound: boolean) => void;
  resetNotFound: () => void;
}

const Error404Context = createContext<Error404ContextType | undefined>(undefined);

interface Error404ProviderProps {
  children: ReactNode;
}

export const Error404Provider: React.FC<Error404ProviderProps> = ({ children }) => {
  const [isNotFound, setIsNotFound] = useState(false);

  const setNotFound = (notFound: boolean) => {
    setIsNotFound(notFound);
  };

  const resetNotFound = () => {
    setIsNotFound(false);
  };

  return (
    <Error404Context.Provider
      value={{
        isNotFound,
        setNotFound,
        resetNotFound,
      }}
    >
      {children}
    </Error404Context.Provider>
  );
};

export const useError404Context = (): Error404ContextType => {
  const context = useContext(Error404Context);
  if (context === undefined) {
    throw new Error('useError404Context must be used within an Error404Provider');
  }
  return context;
};